import { Tooltip } from "@progress/kendo-react-tooltip"
import Translation from "components/Translation"
import { useAppContext } from "context/AppContext"
import { useAuth } from "context/AuthContext"
import getConfig from "next/config"
import { SidebarItem } from "pages/dashboard/Sidebar"
import React from "react"
import { classNames } from "utils/dom-helpers"
import { getTranslation } from "utils/language-helper"

type SidebarItemProps = {
    item: SidebarItem
}

export default function SidebarItemComponent(props: SidebarItemProps) {
    const {
        item
    } = props
    const { translations } = useAppContext()
    const { is_drawer_expanded } = useAuth()
    const item_icon_ref = React.createRef<HTMLSpanElement>()
    const tooltip_ref = React.useRef<Tooltip>(null)
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    return (
        <>
            <span
                className={classNames(
                    item.selected ? 'font-semibold' : ' font-normal',
                    !is_drawer_expanded ? 'text-[22px] leading-[1.1] ml-1' : '',
                    `text-white k-icon ${item.icon}`
                )}
                ref={item_icon_ref}
                title={getTranslation(item.translation_key as string, translations)}
                onMouseOver={event => tooltip_ref.current && tooltip_ref.current.handleMouseOver(event)}
                onMouseOut={event => tooltip_ref.current && tooltip_ref.current.handleMouseOut(event)}
            >
            </span>
            {!is_drawer_expanded &&
                <Tooltip ref={tooltip_ref} anchorElement="target" position="right" tooltipClassName='rounded-lg bg-secondary-blue text-secondary-blue' openDelay={0}
                    content={p =>
                        <div className='w-fit whitespace-normal text-white text-sm font-[450] py-1 px-2'>
                            <Translation
                                content_key={item.translation_key || ""}
                            />
                        </div>
                    }
                />
            }
            <div
                className="item-descr-wrap  w-full"
            >
                <div
                    className={classNames('w-fit text-white',
                        item.selected
                            ? 'font-semibold'
                            : "font-normal",
                    )}
                >
                    <Translation content_key={item.translation_key as string} />
                    {/* TODO: remove when no longer beta */}
                    {item.is_beta &&
                        <span className='bg-secondary uppercase rounded-md inline text-white text-[10px] px-1.5 py-1 ml-1 float-right'>
                            Beta
                        </span>
                    }
                    {item.is_new &&
                        <span className='bg-primary uppercase rounded-md inline text-white text-[10px] px-1.5 py-1 ml-1 float-right'>
                            New
                        </span>
                    }
                </div>

                <span
                    className={classNames(
                        `-mt-6 float-right feather-external-link k-icon text-2x1 text-white font-medium`,
                        !item.external_link ? `hidden` : ``
                    )}
                ></span>
                <div
                    className={classNames(
                        'hover:shadow-yellow-400/50 hover:shadow-lg bg-yellow-400 text-white right rounded-md -mt-6 float-right w-15',
                        !item.is_coming_soon
                            ? `hidden`
                            : ``
                    )}
                    title={getTranslation('coming_soon', translations)}
                >
                    <img
                        className="py-1.5 px-2"
                        src={`https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/roadblock_icon.png`}
                        alt="coming"
                    />
                </div>
            </div>
        </>
    )
}